import { Section } from '../layout/Section'
import { ArrowLeft } from 'lucide-react'

export function PrivacyPolicy() {
    return (
        <Section id="politica-privacidade" background="light">
            <div className="max-w-4xl mx-auto pt-8 md:pt-0">
                {/* Back Link */}
                <a
                    href="/"
                    className="inline-flex items-center gap-2 text-dpxp-primary hover:text-dpxp-secondary mb-8 transition-colors"
                >
                    <ArrowLeft className="w-5 h-5" />
                    Voltar ao início
                </a>

                <h1 className="text-3xl md:text-4xl font-bold text-dpxp-dark mb-8">
                    Política de Privacidade
                </h1>

                <div className="prose prose-lg max-w-none text-dpxp-muted space-y-6">
                    <p className="text-sm text-gray-500">
                        Última atualização: Janeiro de 2026
                    </p>

                    <h2 className="text-xl font-bold text-dpxp-dark mt-8">1. Introdução</h2>
                    <p>
                        A DPXP IT Solutions Ltda. ("DPXP", "nós" ou "nossa") está comprometida em proteger a privacidade dos visitantes do nosso site. Esta Política de Privacidade descreve como coletamos, usamos, armazenamos e protegemos suas informações pessoais, em conformidade com a Lei Geral de Proteção de Dados (LGPD) – Lei nº 13.709/18 – e o Marco Civil da Internet – Lei nº 12.965/14.
                    </p>

                    <h2 className="text-xl font-bold text-dpxp-dark mt-8">2. Aviso sobre o Uso de Cookies</h2>
                    <p>
                        Utilizamos cookies e tecnologias similares para aprimorar sua experiência em nosso site. Cookies são pequenos arquivos de texto armazenados em seu dispositivo que nos ajudam a:
                    </p>
                    <ul className="list-disc pl-6 space-y-2">
                        <li>Lembrar suas preferências de navegação;</li>
                        <li>Analisar o tráfego e o comportamento dos visitantes;</li>
                        <li>Melhorar a performance e funcionalidade do site.</li>
                    </ul>
                    <p>
                        Utilizamos o Google Analytics e Firebase Analytics para entender como você usa nosso site. Você pode configurar seu navegador para recusar cookies, mas algumas funcionalidades podem ser afetadas.
                    </p>

                    <h2 className="text-xl font-bold text-dpxp-dark mt-8">3. Como Coletamos Seus Dados</h2>
                    <p>Coletamos seus dados pessoais por meio de:</p>
                    <ul className="list-disc pl-6 space-y-2">
                        <li><strong>Formulários de contato:</strong> Informações fornecidas voluntariamente quando você nos contata;</li>
                        <li><strong>Navegação no site:</strong> Dados de uso coletados automaticamente via cookies;</li>
                        <li><strong>WhatsApp e E-mail:</strong> Dados compartilhados em conversas diretas;</li>
                        <li><strong>Redes sociais:</strong> Informações públicas de perfis que interagem conosco.</li>
                    </ul>

                    <h2 className="text-xl font-bold text-dpxp-dark mt-8">4. Quais Dados Coletamos</h2>
                    <p>Podemos coletar as seguintes informações:</p>
                    <ul className="list-disc pl-6 space-y-2">
                        <li><strong>Dados de identificação:</strong> nome, e-mail, telefone e empresa;</li>
                        <li><strong>Dados de navegação:</strong> endereço IP, tipo de navegador, páginas visitadas e tempo de permanência;</li>
                        <li><strong>Dados de uso:</strong> interações com nosso site para melhorar a experiência do usuário.</li>
                    </ul>

                    <h2 className="text-xl font-bold text-dpxp-dark mt-8">5. Finalidades do Tratamento</h2>
                    <p>Utilizamos seus dados para:</p>
                    <ul className="list-disc pl-6 space-y-2">
                        <li>Responder às suas solicitações e fornecer suporte;</li>
                        <li>Enviar comunicações sobre nossos serviços (com seu consentimento);</li>
                        <li>Melhorar nosso site, produtos e serviços;</li>
                        <li>Cumprir obrigações legais e regulatórias.</li>
                    </ul>

                    <h2 className="text-xl font-bold text-dpxp-dark mt-8">6. Tempo de Armazenamento</h2>
                    <p>
                        Seus dados pessoais são armazenados durante o período necessário para cumprir as finalidades descritas nesta Política. Após esse período, os dados serão excluídos ou anonimizados, exceto quando a legislação exigir sua conservação.
                    </p>
                    <p>
                        Dados de navegação e analytics são mantidos por até 26 meses. Dados de contato comercial podem ser mantidos enquanto houver relacionamento ativo ou interesse legítimo.
                    </p>

                    <h2 className="text-xl font-bold text-dpxp-dark mt-8">7. Compartilhamento de Dados</h2>
                    <p>
                        Não vendemos ou alugamos suas informações pessoais. Podemos compartilhar dados com:
                    </p>
                    <ul className="list-disc pl-6 space-y-2">
                        <li>Prestadores de serviços essenciais (hospedagem, analytics);</li>
                        <li>Autoridades legais, quando exigido por lei.</li>
                    </ul>

                    <h2 className="text-xl font-bold text-dpxp-dark mt-8">8. Segurança</h2>
                    <p>
                        Implementamos medidas técnicas e organizacionais para proteger suas informações contra acesso não autorizado, alteração, divulgação ou destruição. Utilizamos criptografia TLS e seguimos as melhores práticas de segurança da informação.
                    </p>

                    <h2 className="text-xl font-bold text-dpxp-dark mt-8">9. Seus Direitos (LGPD)</h2>
                    <p>
                        Conforme a Lei Geral de Proteção de Dados, você tem direito a:
                    </p>
                    <ul className="list-disc pl-6 space-y-2">
                        <li>Confirmar a existência de tratamento de dados;</li>
                        <li>Acessar seus dados pessoais;</li>
                        <li>Corrigir dados incompletos ou desatualizados;</li>
                        <li>Solicitar a anonimização, bloqueio ou exclusão de dados;</li>
                        <li>Revogar seu consentimento a qualquer momento.</li>
                    </ul>

                    <h2 className="text-xl font-bold text-dpxp-dark mt-8">10. Seu Consentimento</h2>
                    <p>
                        Ao utilizar nosso site e fornecer seus dados pessoais, você consente com esta Política de Privacidade. Você tem o direito de retirar seu consentimento a qualquer momento, entrando em contato conosco.
                    </p>

                    <h2 className="text-xl font-bold text-dpxp-dark mt-8">11. Contato</h2>
                    <p>
                        Para exercer seus direitos ou esclarecer dúvidas sobre esta política, entre em contato:
                    </p>
                    <p className="font-medium text-dpxp-dark">
                        E-mail: <a href="mailto:privacidade@dpxp.io" className="text-dpxp-primary hover:underline">privacidade@dpxp.io</a>
                    </p>

                    <h2 className="text-xl font-bold text-dpxp-dark mt-8">12. Alterações nesta Política</h2>
                    <p>
                        Podemos atualizar esta Política de Privacidade periodicamente. Alterações significativas serão comunicadas. Ao continuar utilizando nossos serviços após modificações, você demonstra concordância com as novas normas.
                    </p>
                </div>
            </div>
        </Section>
    )
}

